// router/index.ts
import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/auth',
        name: 'auth',
        component: () => import('@/views/LoginView.vue')
    },
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/HomeView.vue')
    },
    {
        path: '/building/:id',
        name: 'building',
        component: () => import('@/views/BuildingView.vue')
    },
    {
        path: '/building/:id/arrivals',
        name: 'arrivals',
        component: () => import('@/views/ArrivalsView.vue')
    },
    {
        path: '/building/:id/faqs',
        name: 'faqs',
        component: () => import('@/views/FaqsView.vue')
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to) => {
    if (to.name === "auth" || sessionStorage.getItem("callcenterAuthenticated") === "true") {
        return true;
    }

    return { name: "auth", query: { redirect: to.fullPath } };
});

export default router;
